/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Settings_Warmup_RestInputs */

const en_us2_workout_logging_settings_warmup_rest = /** @type {(inputs: Workout_Logging_Settings_Warmup_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest after a warm-up set`)
};

const pt_br2_workout_logging_settings_warmup_rest = /** @type {(inputs: Workout_Logging_Settings_Warmup_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso depois do aquecimento`)
};

const es_419_workout_logging_settings_warmup_rest = /** @type {(inputs: Workout_Logging_Settings_Warmup_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso tras una serie de calentamiento`)
};

const pt_pt2_workout_logging_settings_warmup_rest = /** @type {(inputs: Workout_Logging_Settings_Warmup_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso depois do aquecimento`)
};

const fr_fr2_workout_logging_settings_warmup_rest = /** @type {(inputs: Workout_Logging_Settings_Warmup_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repos après une série d'échauffement`)
};

const de_de2_workout_logging_settings_warmup_rest = /** @type {(inputs: Workout_Logging_Settings_Warmup_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause nach einem Aufwärmsatz`)
};

const it_it2_workout_logging_settings_warmup_rest = /** @type {(inputs: Workout_Logging_Settings_Warmup_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero dopo una serie di riscaldamento`)
};

/**
* | output |
* | --- |
* | "Rest after a warm-up set" |
*
* @param {Workout_Logging_Settings_Warmup_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_settings_warmup_rest = /** @type {((inputs?: Workout_Logging_Settings_Warmup_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Settings_Warmup_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_settings_warmup_rest(inputs)
	if (locale === "es-419") return es_419_workout_logging_settings_warmup_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_settings_warmup_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_settings_warmup_rest(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_settings_warmup_rest(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_settings_warmup_rest(inputs)
	return en_us2_workout_logging_settings_warmup_rest(inputs)
});
export { workout_logging_settings_warmup_rest as "workout-logging.settings_warmup_rest" }